import { render, staticRenderFns } from "./WpDepot.vue?vue&type=template&id=45dc2df4&scoped=true&"
import script from "./WpDepot.vue?vue&type=script&lang=js&"
export * from "./WpDepot.vue?vue&type=script&lang=js&"
import style0 from "./WpDepot.vue?vue&type=style&index=0&id=45dc2df4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dc2df4",
  null
  
)

export default component.exports